import axios from 'axios';
import storeMain from '@/store';
import router from '@/router';

export const moduleFantasy = {
  state: {
    competitions: [],
    matchsets: [],
    detailMatchset: {},
    matches: [],
    teams: [],
    players: [],
    contests: [],
    networks: [],
    categories: [],
  },
  mutations: {
    setStatusCodeFantasy(state, payload){
      storeMain.commit('setStatusCode', payload);
    },
    setNotificationFantasy(state, message){
      storeMain.commit('setNotification', message);
    },
    getCompetitions(state, list){
      state.competitions = list;
    },
    getMatchsets(state,list){
      state.matchsets = list;
    },
    getDetailMatchset(state,list){
      state.detailMatchset = list;
    },
    getMatches(state, list){
      state.matches = list;
    },
    getTeams(state,list){
       state.teams = list;
    },
    getPlayers(state, list){
      state.players = list;
    },
    getContests(state,list){
      state.contests = list;
    },
    getNetworks(state,list){
      state.networks = list
    },
    getCategories(state,list){
      state.categories = list
    },
  },
  actions: {

    async getCompetitions({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/competition/list`, config)
          .then((res) => {
            commit('getCompetitions', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createCompetition({ commit, rootState }, competitionData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createCompetition', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/competition/create`,competitionData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createCompetition', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created competition');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy', {key: 'createCompetition', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async toggleCompetition({commit, rootState}, competitionData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'toggleCompetition', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/competition/${competitionData}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleCompetition', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleCompetition', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async editCompetition({commit,rootState}, competitionData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editCompetition', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/competition/${competitionData._id}/edit`,competitionData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editCompetition', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited Competition');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editCompetition', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Competition can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async getMatchsets({commit,rootState}) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/list`, config)
          .then((res) => {
            commit('getMatchsets', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createMatchset({commit,rootState},matchsetData){
      const config = {
        headers: { Authorization: `bearer ${rootState.login.token}` }
      };
      commit('setStatusCodeFantasy',  {key: 'createMatchset', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
        .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/create`, matchsetData.data, config)
        .then((res) => {
          commit('setNotificationFantasy', 'Succesfully created matchset');
          commit('setStatusCodeFantasy',  {key: 'createMatchset', state: res.status, msg:res.statusText, loading: false});
          console.log(res);
        })
        .catch((error) => {
          commit('setStatusCodeFantasy',  {key: 'createMatchset', state: error.response.status, msg: error.response.statusText, loading: false});
          commit('setNotificationFantasy', `Matchset can't be created by ${error.response.statusText}`);
          console.log(error);
        });
    },

    async toggleMatchset({commit,rootState}, competitionData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'toggleMatchset', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/${competitionData}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleMatchset', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleMatchset', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async getDetailMatchset({commit,rootState}, matchsetId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'detailMatchset', state:'', msg:'', loading: true});
      commit('setWarningTime');
      commit('getDetailMatchset',  {});
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/${matchsetId}/detail`, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'detailMatchset', state: res.status, msg:res.statusText, loading: false});
            commit('getDetailMatchset',  res.data);
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'detailMatchset', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async actionMatchset({commit,rootState}, data) {
      const id = data.matchsetId;
      const action = data.type;

      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/${id}/${action}`,{}, config)
          .then(() => {
            commit('setNotificationFantasy', `Succesfully ${action} matchset`);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async editMatchset({commit,rootState}, MatchsetData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editMatchset', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/matchset/${MatchsetData._id}/edit`,MatchsetData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editMatchset', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited matchset');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editMatchset', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Matchset can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async getMatches({commit,rootState}, competitionId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'getMatches', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/match/list?competition=${competitionId}`, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'getMatches', state: res.status, msg:res.statusText, loading: false});
            commit('getMatches', res.data);
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'getMatches', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async actionMatches({commit,rootState}, data) {
      const id = data.matchId;
      const action = data.type;

      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/match/${id}/${action}`,{}, config)
          .then(() => {
            commit('setNotificationFantasy', `Succesfully ${action} matchset`);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async getTeams({commit,rootState}, competitionId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/team/list?competition=${competitionId}`, config)
          .then((res) => {
            commit('getTeams', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async getPlayers({commit,rootState}, competitionId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/player/list?competition=${competitionId}`, config)
          .then((res) => {
            commit('getPlayers', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async getContests({commit,rootState}) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/contest/list`, config)
          .then((res) => {
            commit('getContests', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createContest({commit,rootState}, contestData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createContest', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/contest/create`,contestData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'createContest', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created matchset');

            router.push('/fantasy/contests');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'createContest', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async editContest({commit,rootState}, ContestData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editContest', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/contest/${ContestData._id}/edit`,ContestData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editContest', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited contest');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editContest', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Contest can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async actionContest({commit,rootState}, data) {
      const id = data.contestId;
      const action = data.type;

      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/contest/${id}/${action}`, {}, config)
          .then(() => {
            commit('setNotificationFantasy', `Succesfully ${action} contest`);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async getNetworks({commit,rootState}){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');
      axios.get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/network/list`, config)
          .then((res) => {
            commit('getNetworks', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createNetwork({commit,rootState}, networkData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createNetwork', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/network/create`,networkData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'createNetwork', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created network');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'createNetwork', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Network can't be created by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async editNetwork({commit,rootState}, networkData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editNetwork', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/network/${networkData._id}/edit`,networkData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editNetwork', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited network');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editNetwork', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Network can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async toggleNetwork({commit, rootState}, networkId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'toggleNetwork', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/network/${networkId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleNetwork', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleNetwork', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async getCategories({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'getCategories', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/payout/list`, config)
          .then((res) => {
            commit('getCategories', res.data);
            commit('setStatusCodeFantasy',  {key: 'getCategories', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            console.log(error);
            commit('setStatusCodeFantasy',  {key: 'getCategories', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async createCategories({ commit, rootState }, categoryData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createCategories', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/payout/create`,categoryData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createCategories', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created category');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy', {key: 'createCategories', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async editCategories({commit,rootState}, categoryData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editCategories', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/payout/${categoryData._id}/edit`,categoryData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editCategories', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited category');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editCategories', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Category can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },
  }
};
